import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import connect from 'dojo/_base/connect';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import on from 'dojo/on';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
// template-instantiated child widgets (data-dojo-type in MaintenanceHome.html) — kept as
// side-effect imports so the AMD loader still preloads them (not referenced as values in code).
import "./MaintenanceTaskFilters";
import "./MaintenanceTaskList";
import "../../../moreCore/UI/EntityBased/EntitySelect/EntitySelect";
import template from './MaintenanceHome.html?raw';

class MaintenanceHome extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    dialog: any = null;
    employee: any = null;
    _selectedFiltermode = "";//"MyOccurrences",
    _filtersInitialized = false;
    genericDialog: any = null;

    _currentOffset = 0;

    startup(): void {
        super.startup.apply(this, arguments as any);


        var title = this.translations["MaintenanceHome__MainTitle"];
        if (title == "" || title == null || typeof (title) == "undefined") {
            title = "ekus Wartungsaufträge";
        }
        document.title = title;

        var topBarTitle = document.getElementById("topBarTitle");
        if (topBarTitle) {
            domAttr.set(topBarTitle, "innerHTML", title);
        }

        this.filters.occurrenceList = this.occurrenceList;
        this.list.homePanel = this;
        this.list.startup();

        this.checkSiteAction();

        //on(this.filters, "listresult", lang.hitch(this, this._onGetListResults));
        on(this.filters, "newFiltersettings", lang.hitch(this, this._onFilterSettingsApplied));
        on(this.list, "loadNextResults", lang.hitch(this.filters, "applyFilters"));
        on(this.list, "reloadRequested", lang.hitch(this.filters, "applyFilters"));
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    checkSiteAction(): void {

        var paramNames: any = this.getUrlParameterNames();

        if (paramNames != false) {
            for (var i = 0; i < paramNames.length; i++) {
                var param = paramNames[i];
                var value = this.getUrlParameterValue(param);

                if (value != false) {
                    switch (param.toUpperCase()) {
                        case "VIEW":
                            this.list.showMaintenanceTaskForm(value);
                            return; // RAUS
                            break;

                    }
                }
            }
        }
    }


    _sessionEstablished(): void {
        this._getCurrentEmployee();
    }

    _getCurrentEmployee(): void {

        var employee = null;

        //try {
        //    var employeeTXT = sessionStorage.getItem("currentEmployee");
        //    employee = JSON.parse(employeeTXT);

        //    if (employee && window.sessionInfo) {
        //        if (window.sessionInfo.sessionData.CurrentEmployeeId != employee.ID) {
        //            employee = null;
        //        }
        //    } else {
        //        employee = null;
        //    }
        //} catch (ex) {
        //    employee = null;
        //}

        if (employee != null) {
            this._onGetCurrentEmployeeResponse(employee);
            return;
        }

        this.StandbyStart();
        var url = window.appRoot + "JDM/GetCurrentEmployeeJSON";

        this.RequestManager.post(
            url,
            {
            },
            lang.hitch(this, "_onGetCurrentEmployeeResponse"),
            lang.hitch(this, function (error) {
                console.error("current employee fehler", error.Message);
            }),
            false // sync
        );
    }

    _onGetCurrentEmployeeResponse(response: any): void {
        this.StandbyStop();
        this.employee = response;
        var bIsEditor = false;

        console.log("maintenanceHome currentEmployee", this.employee);

        sessionStorage.setItem("currentEmployee", JSON.stringify(response));

        if (this.employee != null) {
            this.inputLocation._loadListValues(this.employee.ref_last_location, true); // suppress change!
            domClass.remove(this.locationContainer, "w3-hide");
        }

        this.filters.pushStep("employeeLocation");

    }

    // JS2TS: duplicate key in original object literal — this earlier definition of _onLoadListError
    //        was overwritten by the later one (dead code). Kept commented for fidelity.
    //_onLoadListError(error: any): void {
    //    this.StandbyStop();
    //    var message = this.translations["OccurrenceHome__ErrorDialog_HeaderOccurrenceLoad"];
    //    this.showMessage(message, error.message);
    //    //alert(error.message);
    //}

    _onFilterSettingsApplied(stringParams: any, mode: any, offset: any, nextOffset: any): void {

        domClass.remove(this.sectionList, "w3-disabled");

        //console.debug("_onFilterSettingsApplied", stringParams, mode);
        if (this._lastRequestParameters == stringParams) {
            console.warn("duplicate request from filter!", stringParams);
            return;
        }


        this.list.StandbyStart();

        var url = window.appRoot + "JDM/GetTaskExecutionList";

        this._request = this.RequestManager.post(
            url,
            {
                jsonData: stringParams,
                mode: mode
            },
            lang.hitch(this, this._onLoadListResponse, offset, nextOffset, stringParams),
            lang.hitch(this, this._onLoadListError),
            false // sync
        );
    }

    _onLoadListResponse(offset: any, nextOffset: any, stringParams: any, response: any): void {
        //this.StandbyStop();

        this._lastRequestParameters = stringParams;

        this.list.setResult(response, offset, nextOffset);
    }

    _onLoadListError(error: any): void {
        this.StandbyStop();
        this.list.StandbyStop();
        alert("Loading failed - please try again\r\n" + error.Message);
        console.error("_onLoadListError", error.Message);
    }

    _onGetListResults(resultlist: any, offset: any): void {
        this.list.setResult(resultlist, offset);
    }

    _onChangeLocation(value: any): void {
        //console.log("Location geändert", value);
        var additionalFct = lang.hitch(this, "_onSetLocation");

        this._saveUserSettings(additionalFct);
    }

    _onChangeLimitMailsToLocation(): void {
        this._saveUserSettings();
    }

    _saveUserSettings(callback?: any): void {
        this.StandbyStart(this.locationContainer);

        var jsonData = { location: this.inputLocation.get("value") };

        var url = window.appRoot + "JDM/Maintenance_SaveUserSettings";

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(jsonData)
            },
            lang.hitch(this, "_onSaveUserSettingsResponse", callback),
            lang.hitch(this, "_onSaveUserSettingsError"),
            false // sync
        );
    }

    _onSaveUserSettingsResponse(callback: any, response: any): void {
        this.StandbyStop();

        if (typeof (callback) == "function") {
            callback();
        }

    }

    _onSetLocation(): void {
        if (this.employee != null) { // falls gerade der Editor-Filtertab angezeigt wird: Location umschalten auf "null"
            this._lastRequestParameters = null;
            this.employee.ref_last_location = this.inputLocation.get("value");
            this.filters.set("employee", this.employee);

        }
    }

    _onSaveUserSettingsError(error: any): void {
        //this._showLocationMessage(error.Message, "fa-times w3-text-red", 30000);
        this.filters.StandbyStop();
        alert(error.Message);
        this.StandbyStop();
    }

    _showLocationMessage(message: any, iconClass: any, durationMS: any): void {
        this._hideLocationMessage();
        //console.log("location message", typeof (durationMS), durationMS);
        if (typeof (durationMS) != "number") {
            durationMS = 1500;
        }
        domAttr.set(this.locationMessageContent, "innerHTML", message);
        domClass.remove(this.locationMessageIcon);
        domClass.add(this.locationMessageIcon, "fa " + iconClass);
        domClass.remove(this.locationMessageContainer, "w3-hide");
        domStyle.set(this.locationMessageContainer, "opacity", 1);

        setTimeout(lang.hitch(this, "_hideLocationMessage"), durationMS);
    }

    _hideLocationMessage(): void {
        domStyle.set(this.locationMessageContainer, "opacity", 0);

        setTimeout(lang.hitch(this, function () {
            domClass.add(this.locationMessageContainer, "w3-hide");
        }), 3000);

    }

    openExecution(GUID: any): void {

        if (true) {//(this.occurrenceDialog == null) {

        }

    }


    _onEntitySaved(occurrenceDialog: any): void {


    }

    _onChangeSorting(evt: any): void {
        //console.log("sorting changed", this.inputSorting.value);

        if (this.filters != null) {
            this.filters.set("Sorting", this.inputSorting.value);
            return;
        }
    }

    _onChangeSearch(evt: any): void {
        //console.log("search changed", this.inputSearch.value);

        if (this.filters != null) {
            this.filters.set("searchKey", this.inputSearch.value);
            return;
        }
    }

    _onClick_Reload(): void {

        this._lastRequestParameters = null;
        this.filters.applyFilters(0);

    }

    _onLoadNextResults(): void {
        this.filters.applyFilters(this._currentOffset);
    }

    showMessage(header: any, message: any, subtitle?: any, callback?: any): void {
        var dialog = new GenericDialog();

        if (typeof (subtitle) == "string") {
            dialog.set("subtitle", subtitle);
        } else {
            dialog.hideSubtitleNode();
        }

        this.genericDialog = dialog;
        domStyle.set(dialog.textNode, "height", "unset");

        dialog.set("header", header);
        dialog.set("content", message);
        dialog.set("callback", lang.hitch(this, "showMessageCallback", callback));

        dialog.set("ok", true);
        //dialog.set("cancel", true);

        dialog.show();
    }

    showMessageCallback(callback: any): void {
        if (typeof (callback) == "function") {
            callback();
        }

        this.genericDialog = null;
    }

    _setupSubscriptions(): void {
        super._setupSubscriptions.apply(this, arguments as any);

        this._subscriptions.push((connect as any).subscribe("/Session/CheckForExistingSession", lang.hitch(this, "_sessionEstablished")));

    }
}
MaintenanceHome.prototype.declaredClass = 'WidgetCollection.JDM.Maintenance.MaintenanceHome';

export default mdsWidget(MaintenanceHome);
